import { Component, OnInit } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { AppService } from 'src/app/services/app.service';

@Component({
    selector: 'app-pre-inspection-report',
    templateUrl: './pre-inspection-report.component.html',
    styleUrls: ['./pre-inspection-report.component.scss'],
    standalone: false
})
export class PreInspectionReportComponent implements OnInit {
  instructionsData: any;

  constructor(public modalCtrl:ModalController,public _appServices:AppService,public navParams: NavParams) { 
    
    this.instructionsData = navParams.data?.instructionVal;
    if(this.instructionsData == ''){
      this.instructionsData = 'No Instruction Found';
    }
  }

  ngOnInit() {}

  closeModal() {
    this.modalCtrl.dismiss({
      dismissed: true
    });
  }

}
